var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBachelorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19.425,
    viewBox: "0 0 17 19.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-graduate-solid",
    d: "M8.278.067a.94.94,0,0,1,.357,0l7.589,1.518a.909.909,0,0,1,0,1.783l-2.91.584V6.119a4.857,4.857,0,0,1-9.713,0V3.952L1.778,3.588v2.47l.6,2.975a.619.619,0,0,1-.125.5.609.609,0,0,1-.47.224H.564a.6.6,0,0,1-.47-.224.6.6,0,0,1-.125-.5l.6-2.975V3.334A.909.909,0,0,1,.689,1.585ZM4.2,12.482a1.084,1.084,0,0,1,1.116.323l2.694,2.865a.608.608,0,0,0,.884,0L11.59,12.8a1.084,1.084,0,0,1,1.116-.323,6.122,6.122,0,0,1,4.25,5.828,1.165,1.165,0,0,1-1.165,1.165H1.122A1.168,1.168,0,0,1-.043,18.31,6.124,6.124,0,0,1,4.2,12.482Z",
    transform: "translate(0.044 -0.05)",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBachelorIcon);
export default __webpack_public_path__ + "static/media/bachelor-icon.21981fe35054c8231fe41fca1285e308.svg";
export { ForwardRef as ReactComponent };